export default "__VITE_ASSET__Dw_9Qsrr__"